import type {
    IEntitlementUsageDetailsResponse,
    IUsageDetails,
} from '@experiences/interfaces';

export function mapUsageDetailsPerMonth(usageDetails: IUsageDetails, currentDate: Date): IEntitlementUsageDetailsResponse[] {
    const entitlementUsageDetailsList: IEntitlementUsageDetailsResponse[] = [];
    usageDetails.entitlements.forEach(entitlementUsageDetails => {
        const mapByPoolUsage = entitlementUsageDetails.poolsUsage.reduce<{ [pool: string]: number[] }>((prevMap, tr) => {
            const map = { ...prevMap };
            if (map[tr.poolName] === undefined) {
                map[tr.poolName] = Array<number>(12).fill(0);
            }

            const {
                month, year,
            } = extractMonthYear(tr.usageAt);

            if (month <= currentDate.getUTCMonth() && currentDate.getUTCFullYear() !== year) {
                return map;
            }
            map[tr.poolName][month] += tr.consumedQuantity;
            return map;
        }, {});

        entitlementUsageDetailsList.push({
            entitlement: entitlementUsageDetails.entitlement,
            poolsUsage: mapByPoolUsage,
        });
    });
    return entitlementUsageDetailsList;
}

const extractMonthYear = (usageAt: string) => {
    const usage = usageAt.split('/');
    return {
        month: +usage[0] - 1,
        year: +usage[2],
    };
};
